import {createApp} from 'vue'
import options from './TheAside.options'

const el = '.kb-component--the-aside'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((TheAsideDOM)=>{
            const template = TheAsideDOM.outerHTML
            options.template = template
            const component = createApp(options).use(Store)
            component.mount(TheAsideDOM)
        })
    }
}

